<template>
    <div class="shop">
      <!-- Sidebar -->
      <div class="menu">
        <div class="menu-box ps-2 pe-2">
          <div class="menu-items pa-0" v-for="(item, index) in nav" :key="index">
            <router-link
            style="text-decoration: none"
            :to="item.url"
          >
            <div
              class="py-1 ps-3 pe-3 d-flex flex-row justify-between-space"
              :class="
                $router.currentRoute.path.includes(item.url) ? 'active' : ''
              "
            >
              <div
                v-if="messagesNumber.waitingForSignLettersCount"
                class="menu-badge"
              >
                {{ messagesNumber.waitingForSignLettersCount }}
              </div>
              <div class="d-flex justify-content-end align-items-center my-0">
                <span>{{ item.name }}</span>
                <v-icon class="pe-4">{{ item.icon }}</v-icon>
              </div>
            </div>
          </router-link>
          </div>
        </div>
      </div>
      <main class="main">
        <div class="container-fluid pe-5 ps-5">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </template>
  
  <script>
  import nav from "@/_nav";
  import Axios from "axios";
  export default {
    data() {
      return {
        role:'',
        nav: [],
        messagesNumber: {
          notificationCount: 0,
          inboxLettersNotSeenCount: 0,
          internalInboxLettersNotSeenCount: 0,
          assigneLettersLettersCount: 0,
          waitingForSignLettersCount: 0,
          pendingFollowingsLettersCount: 0,
        },

        messagesMenu: false,
      };
    },
    mounted() {
      this.nav = nav["newShop"];
      if (
        !document.body.classList.contains("sidebar-minimized") &&
        !document.body.classList.contains("brand-minimized")
      ) {
        document.body.classList.add("sidebar-minimized");
        document.body.classList.add("brand-minimized");
        // this.toast(
        //   "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
        // );
      }
    },
  };
  </script>
  <style lang="scss">
  .shop {
    position: relative;
    .v-card {
      border-radius: 12px;
      box-shadow: none !important;
      // padding: 16px;
    }
    .menu {
      position: fixed;
      left: 17px;
      top: 54px;
      width: 240px;
      height: calc(100vh - 105px);
      border-right: 1px solid #adb1c25f;
      background-color: #ffffff;
      padding: 15px 0;
      z-index: 31;
      direction: ltr;
  
      .menu-badge {
        height: 24px;
        min-width: 24px;
        max-width: fit-content;
        display: flex;
        padding: 4px 6px;
        justify-content: center;
        background-color: #4c81c9;
        border-radius: 50px;
        color: #fff;
        margin: 8px 0 0 0;
        font-size: 12px;
  
        &:hover {
          background-color: #4c81c9;
          color: #fff;
        }
      }
  
      .logo {
        width: 36px;
        height: 36px;
        margin: auto;
      }
      &-box {
        max-height: calc(100vh - 118px);
       overflow-y: scroll;
        &::-webkit-scrollbar {
          width: 8px;
        }
  
        &::-webkit-scrollbar-track {
          background-color: #eee;
          opacity: 0.5;
          border-radius: 10px;
        }
  
        &::-webkit-scrollbar-thumb {
          background-color: #d4d4d4;
          width: 10px;
          border-radius: 10px; 
        }
      }
      &-items {
        max-height: 250px;
        div {
          width: 100%;
          display: flex;
          justify-content: start;
          margin: 10px 0;
          cursor: pointer;
          border-radius: 12px;
          color: #5f6581;
          path {
            stroke: #5f6581;
          }
  
          &.active {
            background-color: #e7f2fe;
            color: #4c81c9;
            path {
              stroke: #4c81c9;
            }
          }
          &:hover {
            background-color: #e7f2fe;
            color: #4c81c9;
            path {
              stroke: #4c81c9;
            }
          }
        }
      }
    }
    .page-header {
      position: fixed;
      top: 101px;
      z-index: 30;
      width: calc(100% - 297px);
      height: 50px;
      border-bottom: 1px solid rgba(173, 177, 194, 0.272);
      display: flex;
      align-items: center;
      justify-content: end;
      background-color: #ffffff;
      .v-icon {
        position: relative;
      }
      path {
        stroke: #4c81c9;
      }
      .letter-badge {
        position: absolute;
        top: 4px;
        left: 37px;
        background-color: #e22121;
        color: #fff;
        border-radius: 50px;
        min-width: 22px;
        height: 22px;
        display: flex;
        justify-content: center;
        align-content: center;
        padding: 3px 6px;
        font-size: 12px;
      }
    }
    @media only screen and (max-width: 1000px) {
      .page-header {
        width: calc(100% - 266px);
      }
    }
    .main {
      position: absolute;
      right: 0;
      top: 10px;
      width: calc(100% - 218px);
      height: 100%;
      margin-right: 0px !important;
    }
  }
  .messages {
    .image-box {
      width: 68px;
      height: 68px;
      .v-image {
        width: 100%;
        height: 100%;
        border-radius: 50px;
      }
    }
    max-height: 390px;
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 8px;
    }
  
    &::-webkit-scrollbar-track {
      background-color: #eee;
      opacity: 0.5;
      border-radius: 10px;
    }
  
    &::-webkit-scrollbar-thumb {
      background-color: #cdcdcd;
      width: 10px;
      border-radius: 10px;
    }
  }
  .modal-card {
    padding: 20px !important;
    overflow: hidden;
    border-radius: 12px !important;
    .image-box {
      height: 550px;
      pointer-events: none;
    }
    .newLetter-radioBtn {
      .v-label {
        margin: 7px;
        color: #4e536a;
      }
    }
  }
  </style>
  